<template>
  <div id="institution-edit">
    <Modal v-model="modal.visible" :title="modal.title" footer-hide :width="500">

      <IForm :key="modal.visible" :model="edit" :elem="institutionElem" :rules="institutionRule" :loading="loading.form"
             :btn-loading="loading.btn" :width="830" :label-width="100" button button-text="取消" @on-submit="handleSubmit"
             @on-click="modal.visible = false"  :style="{'max-height': '800px', 'min-width': '500px', 'overflow-y': 'auto'}">

        <div slot="extend">
          <FormItem :label-width="80" label="省份" prop="provinceCode"  v-if="!this.edit.id && userType <= 3" style="margin-left: 20px">
            <Select v-model="edit.provinceCode" @on-change="changeProvince">
              <Option v-for="item in provinceList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="城市" prop="cityCode" v-if="!this.edit.id && (edit.provinceCode || userType == 4)" style="margin-left: 20px">
            <Select v-model="edit.cityCode" @on-change="changeCity">
              <Option v-for="item in cityList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="区" prop="areaCode" v-if="!this.edit.id && (edit.cityCode || userType == 5)" style="margin-left: 20px">
            <Select v-model="edit.areaCode" @on-change="changeArea">
              <Option v-for="item in areaList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="80" label="街道"  prop="streetCode" v-if="!this.edit.id && edit.areaCode" style="margin-left: 20px">
            <Select v-model="edit.streetCode">
              <Option v-for="item in streetList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!--
          <FormItem :label-width="80" label="模版" prop="analysisTemplateId"  v-if="!this.edit.id && userType <= 3" style="margin-left: 20px">
            <Select v-model="edit.analysisTemplateId">
              <Option v-for="item in analysisList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
          -->

        <FormItem :label-width="100" label="模版" prop="analysisTemplateId">
            <el-select v-model.trim="edit.analysisTemplateName" placeholder="请选择模版" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleTemplateMethodChange($event)">
              <el-option
                v-for="item in analysisList"
                :key="item.id"
                :label="item.name"
                :value="item"
                style="width:468px"
              />
            </el-select>
          </FormItem>

          <FormItem :label-width="100" label="分析模版" prop="targetTemplateId">
            <el-select v-model.trim="edit.targetTemplateName" placeholder="请选择目标分析模版" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleTargetTemplateMethodChange($event)">
              <el-option
                  v-for="item in analysisList"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                  style="width:468px"
              />
            </el-select>

          </FormItem>

          <FormItem :label-width="100" label="客户套餐" prop="communityId">
            <el-select v-model.trim="edit.collectionLocationName" placeholder="请选择客户套餐" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleRemoteMethodChange($event)">
              <el-option
                v-for="item in communitysList"
                :key="item.id"
                :label="item.collectionLocationName"
                :value="item"
                style="width:468px"
              />
            </el-select>
          </FormItem>

          <FormItem :label-width="100" label="金达机构" prop="jindaId" v-if="jindaShow">
            <el-select v-model.trim="edit.jindaName" placeholder="请选择金达机构" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleJindaMethodChange($event)">
              <el-option
                v-for="item in jindaList"
                :key="item.id"
                :label="item.name"
                :value="item"
                style="width:468px"
              />
            </el-select>
          </FormItem>

          <FormItem :label-width="100" label="账号密码" prop="capId" v-if="capShow">
            <el-select v-model.trim="edit.capName" placeholder="请选择账号密码" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleAccountPasswordMethodChange($event)">
              <el-option
                v-for="item in accountPasswordList"
                :key="item.id"
                :label="item.name"
                :value="item"
                style="width:468px"
              />
            </el-select>
          </FormItem>

          <FormItem :label-width="100" label="社康机构" prop="organId" v-if="organShow">
            <el-select v-model.trim="edit.organName" placeholder="请选择社康机构" clearable filterable  style="width: 468px"
                       size="small" transfer="true" :popper-append-to-body="false"
                       @change="handleOrgansMethodChange($event)">
              <el-option
                v-for="item in organList"
                :key="item.id"
                :label="item.name"
                :value="item"
                style="width:468px"
              />
            </el-select>
          </FormItem>

        </div>
      </IForm>
      <!-- IForm -->
    </Modal>
  </div>
</template>
<script>
import {_editInstitution,_getBaseData,_getCommunityByKey} from "@/services/manage/institutions";
import {getStreetByArea, getAreaByCity, getCityByProvince} from "@/services/manage/tenant";
export default {
  name: "InstitutionEdit",
  data() {
    return {
      provinceList:[],
      cityList:[],
      areaList:[],
      streetList:[],
      jindaList:[],
      analysisList:[],
      communitysList:[],
      accountPasswordList:[],
      organList:[],
      // 带搜索的下拉框
      pageDataDown: {},
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      jindaShow: false,
      capShow: false,
      organShow: false,
      gzTempalte : false,
      szTempalte : false,
      shengYiTempalte : false,
      haiZhuTempalte : false,
      yueXiuTempalte : false,
      panYuTempalte : false,
      userType : null,
      // 表单数据
      edit: {
        name: "",
        subordinate: "",
        labels: "",
        phone: "",
        role: "",
        password: "",
        status: 1,
        filing: 1,
        provinceCode: "",
        cityCode : "",
        areaCode: "",
        streetCode: "",
        analysisTemplateId:"",
        targetTemplateId:"",
        communityId: "",
        jindaId: "",
        capId: "",
        organId: "",
        analysisTemplateName:"",
        targetTemplateName:"",
        collectionLocationName:"",
        jindaName:"",
        capName:"",
        organName:"",
      },
      // 初始表单数据
      init: "",
      // 加载状态
      loading: {
        form: false,
        btn: false,
        customerCode: false,
      },
      // 表单元素
      institutionElem: [
        {
          label: "机构名称",
          prop: "name",
          placeholder: "请输入机构名称"
        },
        {
          label: "子机构名称",
          prop: "subordinate",
          placeholder: "请输入子机构名称"
        },
        {
          label: "标签",
          prop: "labels",
          placeholder: "请输入标签"
        },
        {
          label: "责任医生",
          prop: "doctor",
          placeholder: "请输入责任医生"
        },
        {
          label: "家庭医生",
          prop: "familyDoctor",
          placeholder: "请输入家庭医生"
        },
        {
          label: "联系地址",
          prop: "address",
          placeholder: "请输入联系地址"
        },
        {
          label: "联系电话",
          prop: "phone",
          placeholder: "请输入联系电话"
        },
        {
          label: "建档",
          prop: "filing",
          placeholder: "选择建档",
          element: "select",
          option: [
            {
              label: "关闭",
              value: 1
            }, {
              label: "开启",
              value: 2
            }
          ]
        },
        {
          label: "状态",
          prop: "status",
          placeholder: "选择状态",
          element: "select",
          option: [
            {
              label: "启用",
              value: 1
            }, {
              label: "禁用",
              value: 2
            }
          ]
        },
      ],
      // 表单验证(用户)
      institutionRule: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "机构名不能为空"
          }
        ],
        /*subordinate: [
          {
            required: false,
            trigger: "blur",
            message: "子机构名不能为空"
          }
        ],*/
        labels: [
          { validator: (rule, value, callback) => {
              // 模拟异步验证效果
              if (!value){
                callback(new Error('标签不能为空'));
              } else {
                try{
                  parseInt(value)
                  callback();
                }catch (e) {
                  callback(new Error('请输入数字'));
                }
              }
            },trigger: 'blur' }
        ],
        doctor: [
          {
            required: false,
            trigger: "blur",
            message: "责任医生不能为空"
          }
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            message: "联系电话不能为空"
          }
        ],
        address: [
          {
            required: true,
            trigger: "blur",
            message: "联系地址不能为空"
          }
        ],
        status: [
          {
            required: true,
            trigger: "blur",
            message: "状态不能为空",
            type:'number'
          }
        ],
        provinceCode:[
          {
            required: true,
            message: "请选择省份",
            trigger: "blur",
            type:'number'
          }
        ],
        cityCode:[
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
            type:'number'
          }
        ],
        areaCode:[
          {
            required: true,
            message: "请选择区",
            trigger: "blur",
            type:'number'
          }
        ],
        streetCode:[
          {
            required: true,
            message: "请选择街道",
            trigger: "blur",
            type:'number'
          }
        ],
        analysisTemplateId:[
          {
            required: true,
            message: "请选择模版",
            trigger: "blur",
            type:'number'
          }
        ],
        targetTemplateId: [
          { validator: (rule, value, callback) => {
              // 模拟异步验证效果
              if (this.edit.analysisTemplateId && this.edit.analysisTemplateId == 3 && !value){
                callback(new Error('请选择目标分析模版'));
              } else {
                  callback();
              }
            },trigger: 'blur' }
        ],
      },
    };
  },
  // 初始化
  created() {

    this.gzTempalte = this.$userSession.gzTemplate();
    this.szTempalte = this.$userSession.szTemplate();
    this.shengYiTempalte = this.$userSession.shengYiTemplate();
    this.haiZhuTempalte = this.$userSession.haiZhuTemplate();
    this.yueXiuTempalte = this.$userSession.yueXiuTemplate();
    this.panYuTempalte = this.$userSession.panYuTemplate();
    this.userType = this.$userSession.getUserType();

    // 带搜索的下拉框
    //this.remoteMethod('')
  },
  mounted() {
    this.init = Object.assign({}, this.edit); // 复制初始表单数据
    this.applyBaseData();
  },
  watch:{
    //模版
    'edit.analysisTemplateId': {
      handler(newVal){
        if(newVal && this.shengYi(newVal, this.edit.targetTemplateId)) {
          this.jindaShow = true;
          this.capShow = true;
          this.organShow = false;
        }else if(newVal && this.yueXiu(newVal, this.edit.targetTemplateId)){
          this.jindaShow = true;
          this.capShow = false;
          this.organShow = false;
        }else if(newVal && this.guangzhou(newVal, this.edit.targetTemplateId)){
          this.capShow = true;
          this.jindaShow = false;
          this.organShow = false;
        }else if(newVal && this.shenzhen(newVal, this.edit.targetTemplateId)){
          this.capShow = false;
          this.jindaShow = false;
          this.organShow = true;
        }
      }
    },
  },
  methods: {
    yueXiu(analysisTemplateId, targetTemplateId){
      return this.$userSession.yueXiuTemplate(analysisTemplateId, targetTemplateId);
    },
    shengYi(analysisTemplateId, targetTemplateId){
      return this.$userSession.shengYiTemplate(analysisTemplateId, targetTemplateId);
    },
    panYu(analysisTemplateId, targetTemplateId){
      return this.$userSession.panYuTemplate(analysisTemplateId, targetTemplateId);
    },
    guangzhou(analysisTemplateId, targetTemplateId){
      return this.$userSession.gzTemplate(analysisTemplateId, targetTemplateId);
    },
    shenzhen(analysisTemplateId, targetTemplateId){
      return this.$userSession.szTemplate(analysisTemplateId, targetTemplateId);
    },
    /**清空默认设为空，但是后台方法多数只兼容null.故清空统一为null  2019年7月17日 */
    setValueNull(val) {
      this.edit.collectionLocationName=null;
      this.edit.analysisTemplateName=null;
      this.edit.targetTemplateName=null;
      this.edit.jindaName=null;
      this.edit.capName=null;
      this.edit.organName=null;
    },
    // 下拉框-选值后处理
    handleRemoteMethodChange(item) {
      // 回填下拉框值为正确的值(el-select下拉框获取选中的整个对象值)
      this.edit.communityId = item.id
      this.edit.collectionLocationName = item.collectionLocationName
    },
    handleTemplateMethodChange(item) {
      this.edit.analysisTemplateId = item.id
      this.edit.analysisTemplateName = item.name
    },
    handleTargetTemplateMethodChange(item) {
      this.edit.targetTemplateId = item.id
      this.edit.targetTemplateName = item.name
    },
    handleJindaMethodChange(item) {
      this.edit.jindaId = item.id
      this.edit.jindaName = item.name
    },
    handleAccountPasswordMethodChange(item) {
      this.edit.capId = item.id
      this.edit.capName = item.name
    },
    handleOrgansMethodChange(item) {
      this.edit.organId = item.id
      this.edit.organName = item.name
    },
    applyBaseData(){
      _getBaseData().then(res =>{
        this.jindaList = res.data.jindas;
        this.analysisList = res.data.analysisTemplates;
        this.communitysList = res.data.communitys;
        this.accountPasswordList = res.data.accountPasswords;
        this.organList = res.data.organs;
      })
    },
    //省份选择市
    changeProvince(code, reset){
      if(!code){
        return;
      }
      this.edit.cityCode = "";
      //根据省份编号查询市
      getCityByProvince({province : code}).then(res=>{
        this.edit.provinceCode = code;
        if(res.data){
          this.cityList = res.data;
        }else{
          this.cityList = [];
        }
      })
    },
    //市选择区
    changeCity(code, reset){
      if(!code){
        return;
      }
      this.edit.areaCode = "";
      //根据市编号查询区
      getAreaByCity({cityCode: code}).then(res=>{
        this.edit.cityCode = code;
        if(res.data){
          this.areaList = res.data;
        }else{
          this.areaList =[];
        }
      })
    },
    //区选择街道
    changeArea(code, reset){
      if(!code){
        return;
      }
      this.edit.streetCode = "";
      //根据区编号查询街道
      getStreetByArea({areaCode : code}).then(res=>{
        this.edit.areaCode = code;
        if(res.data){
          this.streetList = res.data;
        }else{
          this.streetList = [];
        }
      })
    },
    loadAreaData(){
      if(this.$userSession.getUserInfo()) {
        let userType = this.userType;
        switch (userType) {
          case 1:
          case 2:
            this.provinceList = this.$userSession.getTenants();
            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 3:
            this.provinceList = this.$userSession.getTenants();
            if(this.provinceList && this.provinceList.length == 1){
              this.changeProvince(this.provinceList[0].code);
              this.edit.provinceCode = this.provinceList[0].code;
            }

            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 4:
            this.provinceList = [];
            this.cityList = this.$userSession.getTenants();
            if(this.cityList && this.cityList.length == 1){
              this.changeCity(this.cityList[0].code);
              this.edit.cityCode = this.cityList[0].code;
            }

            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 5:
            this.provinceList = [];
            this.cityList = [];
            this.areaList = this.$userSession.getTenants();
            if(this.areaList && this.areaList.length == 1){
              this.changeArea(this.areaList[0].code);
              this.edit.areaCode = this.areaList[0].code;
            }
            break;
        }
      }
    },
    /**
     * 显示模态框
     * @param  {string} title 模态框标题名称
     * @param  {object} row 当前行数据
     */
    handleModal(title, row) {
      this.modal = {
        title: title,
        visible: true
      };

      this.loading.form = true; // 表单加载状态
      if (!row) {
        this.loadAreaData();
        this.jindaShow = false;
        this.capShow = false;
        this.edit.analysisTemplateId = "";
        this.edit.targetTemplateId = "";
        this.edit.communityId = "";
        this.edit.jindaId = "";
        this.edit.capId = "";
        this.handleCreate(); // 创建
      } else {
        this.handleEdit(row); // 编辑
      }
    },
    // 创建
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.analysisList.forEach(item=>{
        if (item.type==2){
          this.edit.analysisTemplateId=item.id
        }
      })
      this.loading.form = false
    },
    // 编辑
    handleEdit(row) {
      // 模拟异步请求(获取详情)
      const edit = Object.assign({}, row);
      this.edit = {...edit};
      if (this.edit) {
        this.loading.form = false
      }
      //console.log("this.edit:"+JSON.stringify(this.edit))

      if (this.edit.jindaId){
        this.jindaList.forEach(item=>{
          if (item.id==this.edit.jindaId){
            this.edit.jindaName=item.name
          }
        })
      }

      if(this.edit.capId){
        this.accountPasswordList.forEach(item=>{
          if (item.id==this.edit.capId){
            this.edit.capName=item.name
          }
        })
      }

      if(this.analysisList){
        this.analysisList.forEach(item =>{
          if (this.edit.analysisTemplateId && this.edit.analysisTemplateId == item.id){
            this.edit.analysisTemplateName = item.name;
          }
          if (this.edit.targetTemplateId && this.edit.targetTemplateId == item.id){
            this.edit.targetTemplateName = item.name;
          }
        })

      }

    },
    // 表单提交
    handleSubmit() {
      if ((!this.edit.id || this.edit.id == "") && !this.edit.streetCode) {
        this.$message.warning('请先选择街道');
        return;
      }

      if (!this.edit.analysisTemplateId) {
        this.$message.warning('请选择模版');
        return;
      }

      if (this.edit.analysisTemplateId == 3 && !this.edit.targetTemplateId) {
        this.$message.warning('请选择分析模版');
        return;
      }

      if(this.shengYi(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){

      }else if(this.yueXiu(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){
        this.edit.capId = "";
      }else if(this.$userSession.gzTemplate(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){
        this.edit.jindaId = "";
      }else{
        this.edit.capId = "";
        this.edit.jindaId = "";
      }

      this.$Loading.start();
      this.loading.btn = true;
      const payload = this.edit;
      // 模拟异步请求(编辑 Or 新增)
      _editInstitution(payload)
        .then(res => {
          if (res.errcode == 1){
            if(payload.id && this.$userSession.getInstitutionId() == payload.id){
              this.$userSession.getInstitution().name = payload.name;
              this.$userSession.getInstitution().doctor = payload.doctor;
              this.$userSession.getInstitution().analysisTemplateId = payload.analysisTemplateId;
              this.$userSession.getInstitution().targetTemplateId = payload.targetTemplateId;
              this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
            }

            this.$message.success(res.errmsg);
            this.$emit("on-update");
          } else{
            this.$message.error(res.errmsg);
          }
          this.$Loading.finish();
          this.loading.btn = false;
          this.modal.visible = false;
        }).catch(() => {
          this.$Loading.error();
          this.loading.btn = false;
          this.modal.visible = false;
        });
    },
  },
};
</script>
<style lang="postcss" scoped>
/deep/ .ivu-form-label-right div{
  margin-bottom: 2px;
}

</style>
